import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }: any) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const pageRange = 2;

    if (currentPage > pageRange + 1) {
      pages.push(
        <span
          key='first'
          onClick={() => onPageChange(1)}
          className='cursor-pointer text-[12px] px-2'>
          1
        </span>
      );
      pages.push(<span key='start-ellipsis'>...</span>);
    }

    for (
      let i = Math.max(1, currentPage - pageRange);
      i <= Math.min(totalPages, currentPage + pageRange);
      i++
    ) {
      pages.push(
        <span
          key={i}
          onClick={() => onPageChange(i)}
          className={`cursor-pointer  text-[12px] px-2 ${
            currentPage === i ? "bg-[#F2F4F7] rounded text-[#475467]" : " "
          }`}>
          {i}
        </span>
      );
    }

    if (currentPage < totalPages - pageRange) {
      pages.push(
        <span className='text-[12px]' key='end-ellipsis'>
          ...
        </span>
      );
      pages.push(
        <span
          key='last'
          onClick={() => onPageChange(totalPages)}
          className='cursor-pointer px-2 text-[12px]'>
          {totalPages}
        </span>
      );
    }

    return pages;
  };

  return (
    <div className='pagination flex justify-between items-center py-3 px-6 mx-0'>
      <button
        className='border bg-[#fff]  text-[12px] justify-center items-center flex gap-3 px-2 h-8 font-medium rounded-lg'
        onClick={handlePrevPage}
        disabled={currentPage === 1}>
        {/* <NewIcon name='previousicon' /> */}
        Previous
      </button>

      <div className='flex gap-2'>{renderPageNumbers()}</div>

      <button
        className='border  text-[12px] bg-[#fff] justify-center items-center flex gap-3 px-2 h-8 font-medium rounded-lg'
        onClick={handleNextPage}
        disabled={currentPage === totalPages}>
        Next
        {/* <NewIcon name='nexticon' /> */}
      </button>
    </div>
  );
};

export default Pagination;